/**
 * Klareet-signature glyphs for archetype cards.
 * Small monochrome SVGs that adopt currentColor so we can tint them
 * with the archetype tone. Each glyph reads as a symbol, not a scene.
 */
import React from "react";

const wrap = (children) => (
  <svg viewBox="0 0 64 64" width="44" height="44" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

// One glyph per archetype family; unknown falls back to a compass rose.
const GLYPHS = {
  // Start (Discovery) archetypes
  "The Fixer":        wrap(<><path d="M14 42 L28 28 M22 22 L42 42 M34 14 L50 30" /><circle cx="14" cy="42" r="3" /><circle cx="50" cy="30" r="3" /></>),
  "The Anchor":       wrap(<><path d="M32 12 v40" /><path d="M18 42 a14 14 0 0 0 28 0" /><circle cx="32" cy="14" r="3" /></>),
  "The Creator":      wrap(<><path d="M32 12 L20 44 h24 z" /><path d="M32 22 v14" /></>),
  "The Explorer":     wrap(<><circle cx="32" cy="32" r="18" /><path d="M22 26 L42 32 L22 38 z" /></>),
  "The Main Character": wrap(<><circle cx="32" cy="24" r="8" /><path d="M18 50 c4 -10 24 -10 28 0" /></>),
  "The Lowkey Genius": wrap(<><circle cx="32" cy="32" r="10" /><path d="M32 8 v6 M32 50 v6 M8 32 h6 M50 32 h6 M14 14 l4 4 M46 46 l4 4 M46 18 l4 -4 M14 50 l4 -4" /></>),
  "The Bridge":       wrap(<><path d="M10 40 c8 -18 36 -18 44 0" /><path d="M10 40 h44" /><circle cx="16" cy="40" r="2" /><circle cx="48" cy="40" r="2" /></>),
  "The Steady Hand":  wrap(<><rect x="18" y="20" width="28" height="24" rx="3" /><path d="M24 28 h16 M24 34 h16 M24 40 h10" /></>),
  "The Spark":        wrap(<><path d="M32 8 L36 26 L54 30 L38 36 L34 54 L28 38 L12 34 L28 28 z" /></>),
  "The Storyteller":  wrap(<><path d="M14 18 h30 a4 4 0 0 1 4 4 v20 a4 4 0 0 1 -4 4 h-18 l-8 6 v-6 h-4 a4 4 0 0 1 -4 -4 v-20 a4 4 0 0 1 4 -4 z" /></>),
  // Grow (Operating) archetypes
  "The Builder":      wrap(<><path d="M16 46 h32 v-8 l-16 -18 -16 18 z" /><path d="M28 46 v-10 h8 v10" /></>),
  "The Strategist":   wrap(<><circle cx="32" cy="32" r="16" /><path d="M32 16 v32 M16 32 h32 M22 22 L42 42 M42 22 L22 42" /></>),
  "The Connector":    wrap(<><circle cx="18" cy="32" r="4" /><circle cx="46" cy="18" r="4" /><circle cx="46" cy="46" r="4" /><path d="M22 32 L42 20 M22 32 L42 44" /></>),
  "The Steward":      wrap(<><path d="M32 10 l16 8 v14 c0 12 -8 20 -16 22 c-8 -2 -16 -10 -16 -22 v-14 z" /><path d="M24 30 l6 6 12 -12" /></>),
  "The Investigator": wrap(<><circle cx="26" cy="26" r="12" /><path d="M36 36 l14 14" /></>),
  "The Craftsperson": wrap(<><path d="M18 44 h28 M32 12 v32" /><path d="M22 20 h20 l-4 -6 h-12 z" /></>),
  "The Voice":        wrap(<><path d="M28 20 l18 -6 v36 l-18 -6 z" /><rect x="18" y="26" width="10" height="12" rx="2" /></>),
  "The Compass":      wrap(<><circle cx="32" cy="32" r="18" /><path d="M32 14 v6 M32 44 v6 M14 32 h6 M44 32 h6" /><path d="M32 20 L38 32 L32 44 L26 32 z" /></>),
  "The Pathfinder":   wrap(<><path d="M12 46 C 20 20, 44 44, 52 18" /><circle cx="12" cy="46" r="3" /><circle cx="52" cy="18" r="3" /></>),
  "The Keeper":       wrap(<><rect x="14" y="20" width="36" height="28" rx="3" /><path d="M22 20 v-4 h20 v4" /><circle cx="32" cy="34" r="3" /></>),
};

export function ArchetypeGlyph({ name }) {
  const glyph = GLYPHS[name] || wrap(<><circle cx="32" cy="32" r="18" /><path d="M32 14 v36 M14 32 h36" /></>);
  return glyph;
}
